import image from "../../Assets/Mockups/mockup.png";
import { Link } from "react-router-dom";
import { lipana_signup } from "../../Config/redirect_url";

const Start = () => {
  return (
    <section className="px-6 my-32 text-blackColor xl:px-0 md:my-32">
      <div className="flex flex-col-reverse items-center p-6 mx-auto max-w-6xl h-full bg-white rounded-[20px] shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] md:rounded-[40px] md:flex-row md:p-16">
        <div className="space-y-10 md:w-1/2">
          <h2 className="hidden text-3xl font-semibold lg:text-4xl lg:leading-[3.4rem] md:block">
            Simplify payments <br />
            in your business. <br />
            Use Lipana.
          </h2>

          <h2 className="block text-2xl font-semibold lg:text-4xl lg:leading-[3.4rem] md:hidden">
            Simplify payments in your business. Use Lipana.
          </h2>
          <Link to={lipana_signup()}>
          <button className="w-full bg-brandColor text-white px-10 py-3 font-semibold rounded-full mt-6 md:mt-0 md:w-max">
            Get Started
          </button>
          </Link>
        </div>
        <div className="md:w-1/2">
          <img src={image} alt="" className="w-full object-contain" />
        </div>
      </div>
    </section>
  );
};

export default Start;
